import Api from 'services/apiService.js';
import {
  GET_DEFAULT_RECOMMENDATIONS,
  GET_FILTERED_RECOMMENDATIONS,
  GET_MORE_RECOMMENDATIONS,
  UPDATE_RECOMMENDATION_STATUS,
} from 'actionTypes';

function recommendationStatusEndpoint(endpointArgs) {
  const { recommendationUuid } = endpointArgs;
  return `pse/recommendations/${recommendationUuid}`;
}

function getRecommendationsEndpoint(endpointArgs) {
  const { resultUUID } = endpointArgs;
  return `pse/result/${resultUUID}/recommendations`;
}

export default {
  [GET_DEFAULT_RECOMMENDATIONS]: {
    endpoint: getRecommendationsEndpoint,
    apiFunc: Api.get,
  },
  [GET_FILTERED_RECOMMENDATIONS]: {
    endpoint: getRecommendationsEndpoint,
    apiFunc: Api.get,
  },
  [GET_MORE_RECOMMENDATIONS]: {
    endpoint: getRecommendationsEndpoint,
    apiFunc: Api.get,
  },
  [UPDATE_RECOMMENDATION_STATUS]: {
    endpoint: recommendationStatusEndpoint,
    apiFunc: Api.put,
  },
};



// WEBPACK FOOTER //
// ./src/endpoints/recommendationEndpoints.js